import React from 'react';
import { createPortal } from 'react-dom';
// logic
import { SETTINGS } from '../../../constants';

const PortalContent = ({ children }) => {
  const portalContainer = document.getElementById(SETTINGS.PORTAL_ID);
  return <>{document && portalContainer && createPortal(<>{children}</>, portalContainer)}</>;
};

export default PortalContent;
